import { createStyles, makeStyles } from '@material-ui/core';
import { COLORS } from 'shared/constants/COLORS';
const {
  DARK_BUTTON_BACKGROUND,
  DARK_BUTTON_HOVER,
  DARK_CONTAINER_FIELDS_ON_CARD,
  DARK_FIELDS_FLOATING_TEXTBOX_BACKGROUND,
  DARK_TEXT,
  DARK_TEXTBOX_BACKGROUND,
  LIGHT_CONTAINER_FIELDS_ON_CARD,
  LIGHT_FIELDS_FLOATING_TEXTBOX_BACKGROUND,
  LIGHT_TEXT,
  LIGHT_TEXTBOX_BORDER,
  PLAIN_TEXT,
} = COLORS;

export const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      '& > div:not(:first-child)': {
        marginTop: 10,
      },
      '& .MuiOutlinedInput-root': {
        fontSize: 14,
        background: DARK_TEXTBOX_BACKGROUND,
        borderRadius: 8,
        overflowY: 'auto',
      },

      '& .MuiFormLabel-root': {
        display: 'flex',
        justifyContent: 'space-between',
        fontSize: '13px',
        letterSpacing: '1px',
        alignItems: 'center',
        color: PLAIN_TEXT,
        marginBottom: 5,

        '& .MuiBox-root': {
          padding: '2px 4px 1px 5px',
          border: '1px solid',
          borderRadius: '100%',
          fontSize: '12px',
        },
      },

      '& .MuiSelect-iconOutlined': {
        right: '0',
        top: '20px',
      },

      '& .MuiSelect-iconOpen': {
        top: 0,
        right: '13px',
      },

      '& textarea': {
        borderRadius: 8,
      },
    },

    buttonCls: {
      borderRadius: 8,
      textTransform: 'unset',

      fontSize: 15,
      width: 220,
      height: 50,
      [theme.breakpoints.down('xs')]: {
        width: '100%',
      },
    },
    backBtn: {
      background: DARK_BUTTON_BACKGROUND,
      color: PLAIN_TEXT,
      fontSize: 15,
      width: 220,
      height: 40,
      '&:hover': {
        background: DARK_BUTTON_HOVER,
      },
    },
    checkboxContainer: {
      background: theme.palette.type === 'dark' ? DARK_CONTAINER_FIELDS_ON_CARD : LIGHT_CONTAINER_FIELDS_ON_CARD,
      padding: 20,
      borderRadius: 8,
      marginTop: 7,
      marginBottom: 20,
      flexDirection: 'column',
      '& .MuiTypography-root': {
        fontSize: 14,
        marginTop: -2,
      },
    },
    buttonsContainer: {
      display: 'flex',
      gap: 20,
      justifyContent: 'right',
      [theme.breakpoints.down('xs')]: {
        justifyContent: 'center',
      },
    },
    questionBox: {
      maxHeight: '60vh',
      overflow: 'auto',
      paddingRight: 10,
      [theme.breakpoints.down('xs')]: {
        maxHeight: 'unset',
        paddingRight: 0,
      },
    },
    inputLabelBox: {
      marginBottom: '15px !important',
      fontSize: '17px !important',
      color: (theme.palette.type === 'dark' ? PLAIN_TEXT : LIGHT_TEXT) + '!important',
    },
    textAreaAutoSizeBox: {
      height: 'unset !important',
      width: '100% !important',
      resize: 'none',
      background:
        theme.palette.type === 'dark'
          ? DARK_FIELDS_FLOATING_TEXTBOX_BACKGROUND
          : LIGHT_FIELDS_FLOATING_TEXTBOX_BACKGROUND,
      color: (theme.palette.type === 'dark' ? PLAIN_TEXT : DARK_TEXT) + '!important',
      borderRadius: '4px',
      padding: '10px !important',
      border: 'none',
      fontSize: '16px !important',
      '&:focus': {
        outline: 'none',
        border: `1px solid ${LIGHT_TEXTBOX_BORDER}`,
        boxShadow: 'none',
      },
    },
  }),
);
